//@ts-nocheck
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  fetchOfferFailure,
  fetchOfferRequest,
  fetchOfferSuccess,
  fetchOfferPreferenceFailure,
  fetchOfferPreferenceSuccess,
  fetchOfferPreferenceRequest,
  fetchOfferPrefSubmitFailure,
  fetchOfferPrefSubmitRequest,
  fetchOfferPrefSubmitSuccess,
  fetchViewOffersRequest,
  fetchViewOffersSuccess,
  fetchViewOffersFailure,
} from '../reducer/offerSlice';
import {
  fetchTargetedOffer,
  fetchOfferPreferences,
  fetchTargetOfferPrefSubmit,
  fetchViewOffers,
} from '../api';

interface offerAction {
  type: typeof fetchOfferRequest.type;
  payload: { accountId: string; customerId: string };
}

interface offerPreferenceAction {
  type: typeof fetchOfferPreferenceRequest.type;
  payload: { accountId: string; customerId: string; offerPreference: any };
}

interface targetOfferPrefSubmitAction {
  type: typeof fetchOfferPrefSubmitRequest.type;
  payload: {
    accountId: string;
    customerId: string;
    bankAccountId: string;
    offerStatus: string;
    offerKeyValue: string;
  };
}

interface viewOffersAction {
  type: typeof fetchViewOffersRequest.type;
  payload: { accountId: string; customerId: string };
}

export function* fetchOfferRequestSaga(
  action: offerAction
): Generator<any, void, unknown> {
  console.log('actionoffer', action);
  try {
    const { accountId, customerId } = action.payload;
    const offer: any = yield call(
      fetchTargetedOffer,
      'fetch_targeted_offer',
      accountId,
      customerId
    );
    console.log('offerresponse1 - Raw API Response:', offer);
    console.log('offerresponse1 - Offer Type:', offer?.offerType);
    console.log('offerresponse1 - Offer Status:', offer?.offer_status);
    console.log('offerresponse1 - Expiry Date:', offer?.expiry_date);

    if (offer?.message?.status == '404') {
      console.log('offerresponse2 - 404 Error:', offer);
      yield put(fetchOfferFailure(offer?.message));
    } else {
      console.log('offerresponse3 - Calling fetchOfferSuccess with:', offer);

      // Check if offer has valid data and transform to expected format
      if (
        offer &&
        offer.offerType &&
        ['SCO', 'BT', 'CLI'].includes(offer.offerType)
      ) {
        console.log(
          'offerresponse3 - Valid offer type found:',
          offer.offerType
        );

        // Transform API response to match Offer interface
        const transformedOffer = {
          offerType: offer.offerType,
          offerId: offer.offerId,
          offerDetails: {
            description: offer.description,
            endDate: offer.expiry_date,
            startDate: offer.start_date,
          },
          // Preserve all original API fields
          ...offer,
        };

        console.log('offerresponse3 - Transformed offer:', transformedOffer);
        yield put(fetchOfferSuccess(transformedOffer));
      } else if (offer) {
        console.log(
          'offerresponse3 - Offer data found but no valid offerType, full response:',
          JSON.stringify(offer, null, 2)
        );
        // Still try to save it in case offerType is nested or named differently
        yield put(fetchOfferSuccess(offer));
      } else {
        console.log('offerresponse3 - No offer data received');
        yield put(fetchOfferSuccess([])); // Empty array if no valid offers
      }
    }
  } catch (error: any) {
    console.log('offerresponse4 - Saga Error:', error);
    yield put(fetchOfferFailure(error));
  }
}

export function* fetchOfferPreferenceRequestSaga(
  action: offerPreferenceAction
): Generator<any, void, unknown> {
  try {
    const { accountId, customerId, offerPreference, endDate } = action.payload;
    const offerPreferenceRespnse: any = yield call(
      fetchOfferPreferences,
      'fetch_offerPreferences',
      accountId,
      customerId,
      offerPreference,
      endDate
    );
    if (offerPreferenceRespnse?.statusCode === '200') {
      yield put(fetchOfferPreferenceSuccess(offerPreferenceRespnse));
    } else {
      yield put(fetchOfferPreferenceFailure(offerPreferenceRespnse));
    }
  } catch (error: any) {
    yield put(fetchOfferPreferenceFailure(error || 'Failed to load'));
  }
}

export function* fetchTargetedOfferPrefSubmitRequestSaga(
  action: targetOfferPrefSubmitAction
): Generator<any, void, unknown> {
  try {
    const {
      accountId,
      customerId,
      bankAccountId,
      offerStatus,
      offerKeyValue,
      expiryDate,
    } = action.payload;

    const targetedOfferPrefSubmitResponse: any = yield call(
      fetchTargetOfferPrefSubmit,
      'fetch_targetedOfferPrefSubmit',
      accountId,
      customerId,
      bankAccountId,
      offerStatus,
      offerKeyValue,
      expiryDate
    );
    console.log("response", targetedOfferPrefSubmitResponse, targetedOfferPrefSubmitResponse?.updateResult === 'success');


    if (targetedOfferPrefSubmitResponse?.updateResult === 'success') {
      console.log("success",targetedOfferPrefSubmitResponse);
      yield put(fetchOfferPrefSubmitSuccess(targetedOfferPrefSubmitResponse));
    } else {
      yield put(fetchOfferPrefSubmitFailure(targetedOfferPrefSubmitResponse));
    }
  } catch (error: any) {
    yield put(fetchOfferPrefSubmitFailure(error || 'Failed to load'));
  }
}

export function* fetchViewOffersRequestSaga(
  action: viewOffersAction
): Generator<any, void, unknown> {
  console.log('fetchViewOffersRequestSaga action:', action);
  try {
    const { accountId, customerId } = action.payload;
    const viewOffersResponse: any = yield call(
      fetchViewOffers,
      'fetch_view_offers',
      accountId,
      customerId
    );
    
    console.log('View offers API response:', viewOffersResponse);
    
    if (viewOffersResponse?.message?.status === '404' || viewOffersResponse?.message?.status === '401') {
      console.log('View offers error response:', viewOffersResponse);
      yield put(fetchViewOffersFailure(viewOffersResponse?.message || 'Failed to fetch offers'));
    } else {
      console.log('View offers success response:', viewOffersResponse);
      yield put(fetchViewOffersSuccess(viewOffersResponse));
    }
  } catch (error: any) {
    console.log('View offers saga error:', error);
    yield put(fetchViewOffersFailure(error || 'Failed to load view offers'));
  }
}

export function* watchOfferSagas(): Generator<any, void, unknown> {
  yield takeLatest(fetchOfferRequest.type, fetchOfferRequestSaga);
  yield takeLatest(
    fetchOfferPreferenceRequest.type,
    fetchOfferPreferenceRequestSaga
  );
  yield takeLatest(
    fetchOfferPrefSubmitRequest.type,
    fetchTargetedOfferPrefSubmitRequestSaga
  );
  yield takeLatest(
    fetchViewOffersRequest.type,
    fetchViewOffersRequestSaga
  );
}
